<template>
  <div>
    <slot/>
  </div>
</template>

<script setup>
import Highcharts from "@/highcharts"
import { onMounted } from "vue"

const props = defineProps({
  data: Array,
})

onMounted(() => {
  const categories = props.data.map(d => d.name)
  const data = props.data.map(d => d.count)

  new Highcharts.chart("earningsOnly", {
    chart: { type: "column" },
    title: { text: "Median Monthly Debt Service" },
    subtitle: { text: "As % of Median Earnings" },
    legend: { enabled: false },
    xAxis: {
      categories,
      crosshair: true,
    },
    yAxis: {
      min: 0,
      title: { text: "# of Schools" },
    },
    tooltip: {
      headerFormat: '<span style="color:{series.color};padding:0">{series.name}, {point.key}</span><br>',
      pointFormat: "<b>{point.y} Schools</b>",
      footerFormat: "</table>",
      shared: true,
      useHTML: true,
    },
    plotOptions: { column: { pointPadding: 0, borderWidth: 0, groupPadding: 0, shadow: false } },
    series: [{
      name: "% of Earnings",
      data,
    }],
  })

  $("#compareSchools").dataTable({
    bPaginate: false,
    bInfo: false,
    bFilter: true,
    order: [[4, "desc"]],
    aoColumnDefs: [
      { sType: "html", aTargets: [0, 1] },
      { sType: "html", aTargets: [1] },
      { sType: "title-numeric", aTargets: [2, 5, 6, 7] },
      { sType: "percent", aTargets: [5] },
      { asSorting: ["asc", "desc"], aTargets: [0] },
      { asSorting: ["desc", "asc"], aTargets: ["_all"] },
    ],
    oLanguage: {
      sSearch: "Filter schools:",
    },
  })
})
</script>
